import values from 'lodash/values';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import IconInfo from '@spothero/icons/info';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import TextButton from '@spothero/ui/text-button';
import DOMUtils from '@spothero/utils/dom';
import AmenityUtils from '@spothero/utils/amenity';

export default class AmenitiesList extends Component {
    static propTypes = {
        rate: PropTypes.object,
        isMonthly: PropTypes.bool.isRequired,
        nonRateAmenities: PropTypes.arrayOf(PropTypes.object).isRequired,
        onShowRateDetailsClick: PropTypes.func.isRequired,
    };
    state = {
        showTouchlessModal: false,
    };

    _onRateDetailsClick = evt => {
        evt.preventDefault();

        this.props.onShowRateDetailsClick(
            DOMUtils.attr(evt.currentTarget, 'data-section')
        );
    };

    _onToggleTouchlessModal = evt => {
        this.setState(prevState => ({
            showTouchlessModal: !prevState.showTouchlessModal,
        }));
    };

    _renderIcon(icon) {
        const Icon = AmenityUtils.getIcon(icon);

        if (!Icon) {
            return null;
        }

        return (
            <span className="AmenityIcon">
                <Icon />
            </span>
        );
    }

    _renderInOut() {
        const {rate, isMonthly} = this.props;

        if (rate && isMonthly) {
            const inOut = rate.in_out.allowed;
            const items = [];

            switch (inOut) {
                case 'yes':
                    items.push(
                        <li key={inOut}>
                            {this._renderIcon('in-out')}
                            <span
                                className="AmenitiesList-item-content"
                                data-test="amenity"
                            >
                                Unlimited In/Out
                            </span>
                        </li>
                    );
                    break;

                case 'yes_fee':
                    items.push(
                        <li key={inOut}>
                            {this._renderIcon('in-out')}
                            <span
                                className="AmenitiesList-item-content"
                                data-test="amenity"
                            >
                                Unlimited In/Out
                                <TextButton
                                    data-section="in-out"
                                    onClick={this._onRateDetailsClick}
                                >
                                    with Fee
                                </TextButton>
                            </span>
                        </li>
                    );
                    break;

                case 'yes_limited':
                    items.push(
                        <li key={inOut}>
                            {this._renderIcon('in-out')}
                            <span
                                className="AmenitiesList-item-content"
                                data-test="amenity"
                            >
                                <TextButton
                                    data-section="in-out"
                                    onClick={this._onRateDetailsClick}
                                >
                                    Limited
                                </TextButton>{' '}
                                In/Out
                            </span>
                        </li>
                    );
                    break;

                case 'yes_limited_fee':
                    items.push(
                        <li key={inOut}>
                            {this._renderIcon('in-out')}
                            <span className="AmenitiesList-item-content">
                                Limited In/Out
                                <TextButton
                                    data-section="in-out"
                                    onClick={this._onRateDetailsClick}
                                >
                                    with Fee
                                </TextButton>
                            </span>
                        </li>
                    );
                    break;
            }

            return items;
        } else {
            return null;
        }
    }

    _renderOtherAmenities() {
        const {rate, nonRateAmenities} = this.props;

        if (rate) {
            return values(rate.amenities).map(({slug, name}, i) => {
                return (
                    <li key={i}>
                        {this._renderIcon(slug)}
                        <span
                            className="AmenitiesList-item-content"
                            data-test="amenity"
                        >
                            {name}
                        </span>
                        {slug === 'touchless' && (
                            <TextButton
                                className="AmenitiesList-touchless"
                                onClick={this._onToggleTouchlessModal}
                            >
                                <IconInfo />
                            </TextButton>
                        )}
                    </li>
                );
            });
        } else {
            return nonRateAmenities.map(({visible, slug, name}, i) => {
                if (visible) {
                    return (
                        <li key={i}>
                            {this._renderIcon(slug)}
                            <span
                                className="AmenitiesList-item-content"
                                data-test="amenity"
                            >
                                {name}
                            </span>
                        </li>
                    );
                } else {
                    return null;
                }
            });
        }
    }

    render() {
        const items = values(this._renderInOut()).concat(
            values(this._renderOtherAmenities())
        );

        return (
            <div className="SpotDetails-section">
                <h4 className="subtitle">Amenities</h4>
                <ul className="AmenitiesList">{items}</ul>
                {this.state.showTouchlessModal && (
                    <Modal
                        className="AmenitiesList-touchless-modal"
                        title="Touchless Redemption"
                        onHidden={this._onToggleTouchlessModal}
                    >
                        <ModalContent>
                            This is a self-park facility that doesn&apos;t
                            require you to touch buttons or surfaces to redeem
                            your reservation.
                        </ModalContent>
                    </Modal>
                )}
            </div>
        );
    }
}
